define('campanhas-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('campanhas.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Campanhas', ['$q', '$http', '$location', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, i18n, appRoute, notify, crud, $multipart) {
      return {
        getCampanhas: function(){
          return $q(function (resolve, reject) {
            $http.get($location.absUrl()).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });

        },
        enviaContato: function(obj){
          return $http.post(appRoute.linkTo('contato.enviaContatoCampanha'), obj);
        },
      }
    }]);
});
